import useApi from '@/api/live'
import WX from 'weixin-js-sdk'
import { useStorage } from '@/hooks/web/useStorage'
import { ElMessage } from 'element-plus'
import { getLoginInfo, getRedReceiveInfo } from '@/utils/CryptoJS'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/modules/auth.ts'
import { armsSendCustom } from '@/utils/tools'
import { useAppStore } from '@/store/modules/app'

const appStore = useAppStore()
const { getStorage } = useStorage()
const router = useRouter()

/** 清除链接中的code参数 */
export const delUrlCode = () => {
  const authStore = useAuthStore()
  // 假设当前URL是 https://example.com/?code=123
  const url = new URL(window.location.href) // 解析当前URL
  const code = url.searchParams.get('code') // 获取code=123

  // 清除code参数
  url.searchParams.delete('code')

  authStore.wxCode = code
  // 替换URL为 https://example.com/
  window.history.replaceState({}, '', url.toString())
}

/** 清除链接中的code参数 */
export const delUrlData = () => {
  const authStore = useAuthStore()
  const url = new URL(window.location.href) // 解析当前URL
  const data = url.searchParams.get('data') // 获取code=123

  // 清除code参数
  url.searchParams.delete('data')

  authStore.paramData = data
  // 替换URL为 https://example.com/
  window.history.replaceState({}, '', url.toString())
}

/**
 * 初始化微信相关配置
 */
export const initWxConfig = async (paramsId: string) => {
  const result = await useApi.getAppid(paramsId)
  const res = await useApi.getShareConfig({
    url: window.location.href,
    mpAppId: result?.data?.appid,
    clientId: getStorage('clientId')
  })
  if (res.code === 200) {
    WX.config({
      debug: false,
      appId: res.data.appId,
      timestamp: res.data.timestamp,
      nonceStr: res.data.nonceStr,
      signature: res.data.signature,
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'hideMenuItems', 'requestMerchantTransfer']
    })
    WX.error(function (res) {
      console.log('错误信息', res)
      /* if (res.errMsg == "config:invalid signature") {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } */
    })
  }
}

export const hideShare = () => {
  WX.ready(() => {
    WX.hideMenuItems({
      menuList: [
        'menuItem:share:appMessage',
        'menuItem:copyUrl',
        'menuItem:share:timeline',
        'menuItem:share:qq',
        'menuItem:share:weiboApp',
        'menuItem:share:facebook',
        'menuItem:share:QZone',
        'menuItem:openWithQQBrowser',
        'menuItem:openWithSafari'
      ]
    })
  })
}

/**
 * 分享给微信朋友
 */
export const shareWx = async (params: any) => {
  await initWxConfig(params.paramsId)
  setTimeout(() => {
    WX.ready(() => {
      const imgUrl = params.imgUrl
        ? `${params.imgUrl}?imageMogr2/thumbnail/150x150&t=${new Date().getTime()}`
        : params.imgUrl
      WX.updateAppMessageShareData({
        title: params.title, // 分享标题
        link: params.link, // 分享链接
        desc: params.desc, // 分享描述
        imgUrl: imgUrl, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      })
      WX.updateTimelineShareData({
        title: params.title, // 分享标题
        link: params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function () {
          // 设置成功
        }
      })
    })
  }, 0)
}

/**
 * 新分享 - 给微信朋友
 * 在route中初始化了wx config
 */
export const newShareWx = async (params: any) => {
  WX.ready(() => {
    const imgUrl = params.imgUrl
      ? `${params.imgUrl}?imageMogr2/thumbnail/150x150&t=${new Date().getTime()}`
      : params.imgUrl
    WX.updateAppMessageShareData({
      title: params.title, // 分享标题
      link: params.link, // 分享链接
      desc: params.desc, // 分享描述
      imgUrl: imgUrl, // 分享图标
      success: function () {},
      cancel: function () {},
      fail: function (args) {
        console.error('微信分享失败', args)
      }
    })
    WX.updateTimelineShareData({
      title: params.title, // 分享标题
      link: params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function () {
        // 设置成功
      }
    })
  })
}

/**
 * 处理提现状态
 * @params item
 */
const handleWxWithdrawStatus = (item: any) => {
  const { redPacketId, receiveStatus } = item
  const userId = getLoginInfo('userId') // 用户id
  // 存储 重新组织状态
  const params = {
    redPacketId,
    userId: getLoginInfo('userId'),
    isWithdraw: false, // 提现成功后不能提现
    receiveStatus: receiveStatus > 0 ? 2 : 0
  }
  // receiveStatus: 0 过期 2领取过
  const oldList: any[] = getRedReceiveInfo('redReceiveList') ? getRedReceiveInfo('redReceiveList') : []
  // 判断是否添加
  const hasRedID = oldList.find((item: any) => item.redPacketId === redPacketId)
  let newList: any[] = oldList
  // 添加过
  if (hasRedID) {
    newList = oldList.map((item: any) => {
      const newItem = {
        ...item
      }
      if (item.redPacketId === redPacketId) {
        newItem.isWithdraw = 0
      }
      return newItem
    })
  }
  {
    newList = oldList.concat([params])
  }
  console.log(' handleWxWithdrawStatus ~~~~~~~~~~~~----> newList', newList)
  // 永久缓存
  useStorage('localStorage').setStorage(`redReceive_${getStorage('roomId')}_${userId}`, { redReceiveList: newList })
}
/**
 * 微信提现交互
 * @params mchId  appId package redPacketId receiveStatus
 */
export const wxWithdrawH5 = async (params: any) => {
  await initWxConfig(params.paramsId)
  return new Promise((resolve, reject) => {
    WX.ready(() => {
      WX.checkJsApi({
        jsApiList: ['requestMerchantTransfer'],
        success: (res: any) => {
          console.log(' WX.ready提现 ~~~~~~~~~~~~----> res', res)
          if (res.checkResult['requestMerchantTransfer']) {
            WeixinJSBridge.invoke(
              'requestMerchantTransfer',
              {
                mchId: params.mchId /* 商户号 */,
                appId: params.appId,
                package: params.package
              },
              (res: any) => {
                console.log(' 微信提现交互======res', res)
                // res.err_msg将在页面展示成功后返回应用时返回success，并不代表付款成功
                if (res.err_msg === 'requestMerchantTransfer:ok') {
                  resolve(true)
                  // ElMessage.success("提现成功");
                  // handleWxWithdrawStatus(params) // 暂存注
                } else {
                  reject()
                }
                resolve(true)
              }
            )
          } else {
            ElMessage.warning('你的微信版本过低，请更新至最新版本。')
            resolve(false)
          }
        }
      })
    })
  })
}

/**
 * 跳转到微信授权页面
 */
export const redirectWxAuthorize = async (appId: string, componentAppId: string, redirectUri: string, watchDomainObj: object = {}) => {
  try {
    const oauthBaseUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize'

    const authRedirectUri = await getWxAuthRedirectUri(redirectUri, watchDomainObj)

    let paramsArr = [
      `appid=${appId}`,
      `redirect_uri=${encodeURIComponent(authRedirectUri as string)}`,
      `response_type=code`,
      `scope=snsapi_userinfo`,
      `state=1`,
      `connect_redirect=1`,
      `snsapi_userinfo=1`
    ]
    if (componentAppId) {
      paramsArr.push(`component_appid=${componentAppId}`,)
    }
    const paramString = paramsArr.join('&')
    const wxUrl = `${oauthBaseUrl}?${paramString}#wechat_redirect`

    if (!appId) {
      armsSendCustom('wx_auth_no_appid', '微信授权无APPID参数', { appId, componentAppId, paramString })
    }
    window.location.replace(wxUrl.replace(/\s+/g, ''))
  } catch (error) {
    console.error(error)
    router.replace({ path: '/nopremission/2' }).then()
  }
}

/** 获取授权重定向地址 */
export const getWxAuthRedirectUri = (url: string, watchDomainObj: any = {}) => {
  return new Promise(async (resolve) => {
    try {
      const { watchDomainProtocol, watchDomain } = watchDomainObj
      const res = await useApi.saveAuthUrl({
        watchUrl: replaceUrlDomain(url, `${watchDomainProtocol}://${watchDomain}`)
      })
      const { code, data } = res
      if(code !== 200 || !data) return resolve(url)
      const domain = getUrlDomain(url)
      resolve(`${domain}/wxAuthSkip/param?p=${data.authParm}`)
    } catch (error) {
      return resolve(url)
    }
  })
}

/** 获取指定链接的通信协议+域名 */
export const getUrlDomain = (url: string): string => {
  try {
    const parsed = new URL(url, window.location.origin)
    return `${parsed.protocol}//${parsed.hostname}`
  } catch {
    return ''
  }
}

/** 替换指定链接的协议+域名 */
export const replaceUrlDomain = (url: string, domain: string): string => {
  try {
    const parsed = new URL(url, window.location.origin)
    const normalizedDomain = domain.replace(/\/+$/, '')
    return `${normalizedDomain}${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return url
  }
}
